import React from 'react';
import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';
import { useSelector } from 'src/store';
import { SocketDataInterface } from 'src/types/socket';

interface AuthGuardProps {
  children?: ReactNode;
}

const AuthGuard: FC<AuthGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const { isConnected }: SocketDataInterface = useSelector((state) => state.socket);
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  if(isAuthenticated && window.location.pathname !== '/select-tunnel' && !isConnected){
    return <Navigate to="/select-tunnel" />;
  }
  
  return (
    <>
      {children}
    </>
  );
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
